module.exports = __webpack_public_path__ + "static/flight-3b2c8a35e32d6f96c26a58d0dbae4fd6.png";